var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content && _vm.content.contentvalue != undefined)?_c('toggle-button',{staticClass:"mt-2",staticStyle:{"display":"inline-block"},attrs:{"value":_vm.content.contentvalue,"sync":true,"color":_vm.$vuetify.theme.success,"labels":{ checked: 'ON', unchecked: 'OFF' }},on:{"change":_vm.onSwitch}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8477030","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/setting/input-no-label/InputBooleanNoLabel.vue
// module id = null
// module chunks = 